import { get, put } from '../../ReaderlyHttpClient';
import { Item } from '../Data';

export interface SaveItemRequest {
  itemId: number;
  count: number;
}

export interface SaveCartRequest {
  items: SaveItemRequest[];
}

interface GetCartResponse {
  items: Item[];
  total: number;
}

export class CartsService {
  async GetCart(): Promise<Item[]> {
    const token = localStorage.getItem('token');
    if (!token) {
      return [];
    }

    const response = await get<GetCartResponse | undefined>('Carts', undefined, { suppressGlobalError: true });
    return response?.items ?? [];
  }

  async SetCart(items: SaveItemRequest[]): Promise<Item[]> {
    const processedItems = items
      .filter((item) => item.itemId > 0)
      .map((item) => ({
        itemId: item.itemId,
        count: Math.max(0, item.count ?? 1),
      }));

    const request: SaveCartRequest = { items: processedItems };
    const response = await put<GetCartResponse, SaveCartRequest>('Carts', request, undefined, { suppressGlobalError: true });
    return response.items ?? [];
  }
}

const cartsServiceInstance = new CartsService();
export default cartsServiceInstance;
